import React, { useEffect } from 'react'
import qs from 'query-string'

const options = [
    {
        label: 'Featured',
        value: 'featured',
    },
    {
        label: 'New Arrivals',
        value: 'new-arrivals',
    },
    // {
    //     label: 'Best Selling',
    //     value: 'best-selling',
    // },
    {
        label: 'Alphabetical: A–Z',
        value: 'a-z',
    },
    {
        label: 'Alphabetical: Z–A',
        value: 'z-a',
    },
    {
        label: 'Price: Low to High',
        value: 'low-high',
    },
    {
        label: 'Price: High to Low',
        value: 'high-low',
    },
]

const SortBy = React.memo(({ sortBy, handleSort }) => {
    useEffect(() => {
        // console.log('variantsReady in SortBy', variantsReady)
        const parsed = qs.parse(window.location.search)

        // console.log('parsed queryString in SortBy', parsed)

        if (parsed['sort']) {
            const sortValue = parsed['sort']
            // console.log('sort query param; sort value', sortValue)

            handleSort(sortValue)
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div className="sortby-outer">
            <div className="sortby-inner">
                <select
                    className="select-sort"
                    defaultValue={sortBy}
                    onChange={({ target: { value } }) => handleSort(value)}
                    aria-label="Sort by"
                >
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
})

export default SortBy
